import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  LuSettings,
  LuBriefcaseBusiness,
  LuPanelsTopLeft,
  LuUsersRound,
  LuCalendar,
  LuCompass,
  LuList,
  LuUserSearch,
  LuUserCog,
  LuCircleDollarSign,
  LuLogOut,
  LuLayers,
  LuWarehouse,
  LuBriefcase,
  LuFileText,
} from "react-icons/lu";

import { SidebarItem } from "./sidebar-item";
import { useAppDispatch } from "../../data/store/hooks";
import { logout } from "../../data/store/reducers/userSlice";

export const Sidebar = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const dispatch = useAppDispatch();

  const [expandedUsers, setExpandedUsers] = useState(false);
  const [expandedPosts, setExpandedPosts] = useState(false);

  const isUsersActive = pathname.startsWith("/users");
  const isPostsActive = pathname.startsWith("/posts");

  const LuPanelsTopLeftIcon = LuPanelsTopLeft as React.ElementType;

  return (
    <div
      className="hidden md:block border rounded-b-2xl md:w-1/4 lg:w-1/6 z-0"
      style={{ height: "100%" }}
    >
      <div className="flex items-center space-x-2 py-6 px-4">
        <LuPanelsTopLeftIcon size={25} className="text-gray-900" />
        <span className="font-semibold text-gray-900">Admin Dashboard</span>
      </div>
      <hr />
      <div>
        <div className="ml-6 mt-4 mb-2 text-xs text-gray-400 font-bold">
          MAIN
        </div>
        <div className="px-2 flex flex-col space-y-1">
          <SidebarItem
            label="Overview"
            icon={LuCompass}
            isActive={pathname === "/"}
            onClick={() => navigate("/")}
          />

          <SidebarItem
            label="Users"
            icon={LuUsersRound}
            isActive={!expandedUsers && isUsersActive}
            onClick={() => setExpandedUsers(!expandedUsers)}
            hasSubItems
            isExpanded={expandedUsers}
          />
          {expandedUsers && (
            <>
              <SidebarItem
                label="All users"
                icon={LuUserCog}
                isActive={pathname === "/users/all"}
                onClick={() => navigate("/users/all")}
                indentLevel={1}
              />
              <SidebarItem
                label="Professionals"
                icon={LuBriefcase}
                isActive={pathname === "/users/professionals"}
                onClick={() => navigate("/users/professionals")}
                indentLevel={1}
              />
              <SidebarItem
                label="Employers"
                icon={LuUserSearch}
                isActive={pathname === "/users/employers"}
                onClick={() => navigate("/users/employers")}
                indentLevel={1}
              />
            </>
          )}
        </div>
        <div className="ml-6 mt-4 mb-2 text-xs text-gray-400 font-bold">
          GENERAL
        </div>
        <div className="px-2 flex flex-col space-y-1">
          <SidebarItem
            label="Posts"
            icon={LuList}
            isActive={!expandedPosts && isPostsActive}
            onClick={() => setExpandedPosts(!expandedPosts)}
            hasSubItems
            isExpanded={expandedPosts}
          />
          {expandedPosts && (
            <>
              <SidebarItem
                label="Jobs"
                icon={LuBriefcase}
                isActive={pathname === "/posts/jobs"}
                onClick={() => navigate("/posts/jobs")}
                indentLevel={1}
              />
              <SidebarItem
                label="Projects"
                icon={LuFileText}
                isActive={pathname === "/posts/projects"}
                onClick={() => navigate("/posts/projects")}
                indentLevel={1}
              />
            </>
          )}
        </div>
        <div className="px-2 mt-1 flex flex-col space-y-1">
          <SidebarItem
            label="Applications"
            icon={LuBriefcaseBusiness}
            isActive={pathname === "/applications"}
            onClick={() => navigate("/applications")}
          />
          <SidebarItem
            label="Interviews"
            icon={LuCalendar}
            isActive={pathname === "/interviews"}
            onClick={() => navigate("/interviews")}
          />
          <SidebarItem
            label="Transactions"
            icon={LuCircleDollarSign}
            isActive={pathname === "/transactions"}
            onClick={() => navigate("/transactions")}
          />
        </div>
        <div className="ml-6 mt-4 mb-2 text-xs text-gray-400 font-bold">
          CONFIGURATION
        </div>
        <div className="px-2 flex flex-col space-y-1">
          <SidebarItem
            label="Categories"
            icon={LuLayers}
            isActive={pathname === "/categories"}
            onClick={() => navigate("/categories")}
          />
          <SidebarItem
            label="Industries"
            icon={LuWarehouse}
            isActive={pathname === "/industries"}
            onClick={() => navigate("/industries")}
          />

          <SidebarItem
            label="Settings"
            icon={LuSettings}
            isActive={pathname === "/settings"}
            onClick={() => navigate("/settings")}
          />
          <SidebarItem
            label="Logout"
            icon={LuLogOut}
            isActive={pathname === "/logout"}
            onClick={() => {
              dispatch(logout());
              navigate("/auth/sign-in");
            }}
          />
        </div>
      </div>
      <hr className="mt-4" />
      <div className="p-6 text-gray-400">
        <div className="flex items-center space-x-1 text-sm">
          <p className="">&copy; 2025</p>
          <p>BCT.Design</p>
        </div>
        <p className="mt-1 text-xs">Connecting the dots for great talents...</p>
      </div>
    </div>
  );
};

export default Sidebar;
